import { Button, Row, Table } from 'antd';
import './webhookHistory.scss';
import InfiniteScroll from 'react-infinite-scroller';
import { useState } from 'react';
import { CloseIcon3 } from 'components/Icons';
export const WebhookHistoryTable = ({ data, columns, loading, hasMore, loadMore, resendAll }) => {
  const [selectedRows, setSelectedRows] = useState([]);
  const [isShowResendAllToast, setIsShowResendAllToast] = useState(true);

  // Create 10 fake records for loading state
  const createFakeRecords = () => {
    const fakeRecords = [];

    for (let i = 0; i < 8; i++) {
      fakeRecords.push({
        isFake: true,
      });
    }
    return fakeRecords;
  };

  // rowSelection object indicates the need for row selection
  const rowSelection = {
    selectedRows,
    onChange: (selectedRowKeys) => {
      setSelectedRows(selectedRowKeys);
      setIsShowResendAllToast(true);
    },
    getCheckboxProps: (record) => ({
      name: record.name,
    }),
  };

  return (
    <div>
      {selectedRows.length > 0 && isShowResendAllToast && (
        <Row className="selected-row-section-wrapper" align="middle">
          <span className="selected-row-section-text">{selectedRows.length} selected</span>
          <Button className="medium-btn resend-all-btn" onClick={() => resendAll(selectedRows)}>
            Resend all
          </Button>
          <CloseIcon3
            className="close-action-icon"
            onClick={() => {
              setIsShowResendAllToast(false);
            }}
          />
        </Row>
      )}
      <InfiniteScroll
        pageStart={0} // start at page 0
        loadMore={loadMore} // your API fetch
        hasMore={!loading && hasMore}
        useWindow={false} // use table body scroll
        initialLoad={false} // 🚀 prevent auto-trigger on mount
        disabled={loading}
        loader={<div className="loader">Loading ...</div>}
        getScrollParent={() => document.querySelector('.wh-container > :nth-child(2)')}>
        <Table
          className="webhook-history-table"
          rowKey="_id"
          rowSelection={{
            type: 'checkbox',
            ...rowSelection,
          }}
          columns={columns}
          dataSource={loading ? createFakeRecords() : data}
          pagination={false}
          prefixCls="wh"
          scroll={{ x: 'max-content', y: 'calc(100vh - 420px)' }}
        />
      </InfiniteScroll>
    </div>
  );
};
